import clsx from "clsx";
import { forwardRef } from "react";

// `lg` is the large button of the decision block (SCR-03); `md` is the default and stays as it was for SCR-01.
const SIZES = {
  md: "px-3 py-1.5 text-xs font-medium rounded-lg text-text",
  lg: "h-[44px] px-4 text-sm font-semibold rounded-xl text-accent-solid",
  modal: "h-[52px] px-6 text-sm font-semibold rounded-xl text-accent-solid flex-[1_1_180px]",
};

const GhostButton = forwardRef(function GhostButton({ children, size = "md", className, ...rest }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      className={clsx(
        "inline-flex items-center justify-center border border-border bg-surface",
        SIZES[size],
        "hover:bg-surface-alt disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-surface",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
});

export default GhostButton;
